import React, { Component } from "react";
import TranslationSpecific from "./TranslationSpecific";
import styles from "../translations/Translation.module.scss";
import AddNewTranslation from "./AddNewTranslation";
import { Grid, Link } from "@material-ui/core";
import crStyles from "../customerReservation/crStyles";
import TranslationsClient from "./TranslationsClient";
import { LANCODES } from "../../common/Constants";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../shared/ExpansionPanels/ExpansionPanel";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class TranslationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNewTranslation: false,
      showInput: true,
      isTranslationAccordionExpanded: false,
    };
  }

  onClick = () => {
    this.setState({ showNewTranslation: true });
    this.setState({ showInput: false });
  };

  cancelSpecificTranslation = () => {
    this.setState({ showNewTranslation: false });
    this.setState({ showInput: true });
  };

  addSpecificTranslation = (updatedLanguage) => {
    this.props.hideOrShow(true);
    TranslationsClient.postAddTranslations(
      updatedLanguage,
      this.props.getMarketsForNewTranslations(),
      this.props.user
    )
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        this.setState({ showInput: true });
        this.setState({ showNewTranslation: false });
        this.props.hideOrShow(false);
        this.props.getTranslations();
      });
  };

  toggleTranslationAccordionExpansion() {
    this.setState((prevState) => ({
      isTranslationAccordionExpanded: !prevState.isTranslationAccordionExpanded,
    }));
  }

  render() {
    return (
      <div>
        <br />
        <StyledBasicExpansionPanel
          defaultExpanded={true}
          styles={crStyles.expansionPanel}
          onChange={() => this.toggleTranslationAccordionExpansion()}
        >
          <StyledBasicExpansionPanelSummary style={crStyles.headerBarNeutral}>
            <div className={styles.headerBar}>
              <div className={styles.boldHeader}>
                {this.props.translations.moduleKey}
              </div>
              {this.state.isTranslationAccordionExpanded ? (
                <ExpandMoreIcon id="more" />
              ) : (
                <ExpandLessIcon id="less" />
              )}
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>
          <div className={styles.translationGrid}>
            <div className={styles.bottomBorder}></div>
          </div>
          <Grid container className={styles.translation_header}>
            <Grid item md={3} className={styles.lanHeader}>
              {this.props.t("Translations.key")}
            </Grid>
            <Grid item md={4} className={styles.lanHeader}>
              {LANCODES["en"]}
            </Grid>
            <Grid item md={4} className={styles.lanHeader}>
              {LANCODES[this.props.currentLan]}
            </Grid>
            <Grid item md={1} className={styles.actionHeader}>
              {this.props.t("Translations.action")}
            </Grid>
          </Grid>

          <div>
            {Object.keys(this.props.translations.languages).length !== 0
              ? Object.keys(this.props.translations.languages).map((lan) => {
                  return (
                    <TranslationSpecific
                      {...this.props}
                      language={this.props.translations.languages[lan]}
                      moduleKey={this.props.translations.moduleKey}
                      key={this.props.translations.languages[lan].key}
                    />
                  );
                })
              : null}
          </div>

          <div className={styles.translation_header}>
            <div
              style={{
                position: "relative",
                float: "left",
                paddingBottom: "15px",
              }}
            >
              {this.state.showInput ? (
                <Link
                  className={styles.newTranslation}
                  style={{ color: "#102b4e" }}
                  variant="contained"
                  onClick={this.onClick}
                >
                  {this.props.t("Translations.addNewTrans")}
                </Link>
              ) : null}
            </div>
          </div>
          {this.state.showNewTranslation ? (
            <AddNewTranslation
              {...this.props}
              moduleKey={this.props.translations.moduleKey}
              cancelSpecificTranslation={this.cancelSpecificTranslation}
              addSpecificTranslation={this.addSpecificTranslation}
            />
          ) : null}
        </StyledBasicExpansionPanel>
      </div>
    );
  }
}

export default TranslationTable;
